import { getNow } from "@/helpers/date_time";

export function getMidnight(timestamp = 0) {
    timestamp = (timestamp || +getNow())*1000;
    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0);
    return date.getTime()/1000;
}